import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import { jpgImages, videos, formatDropboxUrl } from '../../data/galleryMedia';

const { FiArrowRight, FiPlay } = FiIcons;

export default function BeforeAfter() {
  // Combine 4 best JPGs and 4 spread-out Videos from the new list for the home page showcase mixed-media grid
  const showcaseItems = [
    { type: 'jpg', url: jpgImages[1] },
    { type: 'video', url: videos[0] },
    { type: 'jpg', url: jpgImages[3] },
    { type: 'video', url: videos[7] },
    { type: 'jpg', url: jpgImages[4] },
    { type: 'video', url: videos[12] },
    { type: 'jpg', url: jpgImages[6] },
    { type: 'video', url: videos[21] }
  ];

  return (
    <section className="py-24 bg-slate-900 border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center mb-14">
          <span className="text-blue-500 font-bold tracking-widest uppercase text-xs mb-3 block">
            The Difference Is In The Detail
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-white uppercase tracking-tight mb-4">
            Real Results
          </h2>
          <p className="text-slate-400 max-w-xl mx-auto">
            Real vehicles. Real details. Real work from A.R. Elite Detailing. No stock photos—just genuine transformations.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 lg:gap-4 mb-12">
          {showcaseItems.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className="group relative aspect-[4/5] bg-slate-950 overflow-hidden border border-slate-800 hover:border-blue-500/40 transition-colors rounded-sm"
            >
              {item.type === 'jpg' ? (
                <img 
                  src={formatDropboxUrl(item.url)} 
                  alt="A.R. Elite Detailing - Real Results" 
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 opacity-90 group-hover:opacity-100"
                  loading="lazy"
                />
              ) : (
                <>
                  <video 
                    src={formatDropboxUrl(item.url)} 
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 opacity-80 group-hover:opacity-100"
                    muted playsInline
                    onMouseEnter={(e) => {
                      if (e.target.ended) e.target.currentTime = 0;
                      e.target.play().catch(() => {});
                    }}
                    onMouseLeave={(e) => e.target.pause()}
                  />
                  <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                    <div className="w-10 h-10 bg-black/40 backdrop-blur-md rounded-full flex items-center justify-center border border-white/20 group-hover:bg-blue-600/80 group-hover:border-blue-400 transition-all duration-300 group-hover:scale-110">
                      <FiPlay className="text-white text-sm ml-0.5" />
                    </div>
                  </div>
                </>
              )}
            </motion.div>
          ))}
        </div>

        <div className="text-center">
          <Link 
            to="/gallery" 
            className="inline-flex items-center gap-2 px-8 py-4 bg-blue-600 text-white font-bold rounded-sm hover:bg-blue-500 transition-all uppercase tracking-wide text-sm shadow-[0_4px_20px_rgba(37,99,235,0.3)] hover:-translate-y-0.5"
          >
            View Full Gallery <FiArrowRight />
          </Link>
        </div>

      </div>
    </section>
  );
}